<template>
  <div class="guide-container" v-if="isShowGuide">
    <div class="guide-overlay"></div>

    <div class="guide-content">
      <button  @click="closeGuide"
      class="icon-close" 
        style="float: inline-end; width: 32px;
height: 32px;opacity: 1;font-size: x-large;margin-right: 11px;"></button>
      <h2 class="guide-title">{{ guideTitle }}</h2>
    

      <b-carousel
        id="guide-carousel"
        ref="guide-carousel"
        v-model="currentSlide"
        label-next="NEXT"
        label-prev="BACK"
        :height="carouselHeight"
        :per-page="slidesPerView"
        :breakpoints="{ md: { perPage: 2 } }"
        controls
        indicators
        :interval="0"
      >
      <template v-slot:carousel-control-prev>
      <b-button v-if="currentSlide > 1"></b-button>
    </template>
        <b-carousel-slide v-for="slide in slides" :key="slide.id">
          <p class="carousel-sub-title">{{ slide.title }}</p>
          <!-- <base-grid-status
                        :statusType="'approved'"
                        :class="'mb-3'"
                        ></base-grid-status>     -->
          <img :src="slide.imageOneUrl" alt="Guide Step Illustration" class="slide-image" />
          <img :src="slide.imageTwoUrl" alt="Guide Step Illustration" class="slide-image" />
        </b-carousel-slide>
        
      </b-carousel>
      <div class="guide-actions">
                    <b-button
                        type="submit"
                        variant="primary"
                        :disabled="currentSlide !=6"
                        :class="{ 'btn-disabled': currentSlide !=6}"
                        @click="onSubmit()"
                    >I have understood!</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BCarousel, BCarouselSlide } from 'bootstrap-vue';
import { mapGetters,mapMutations } from 'vuex';

export default {
  name: 'CarouselGuide',
  components: {
    BCarousel,
    BCarouselSlide,
  },
  props: {},
  data() {
    return {
      currentSlide: 0,
      carouselHeight: 400,
      slidesPerView: 2, 
      showPreviousButton: true,
      guideTitle: 'Photo requirements',
      slides: [
          {
            id: 1,
            imageOneUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-1.png`,
            imageTwoUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-2.png`, 
            title: 'Please make sure the document is straight in the picture and not tilted',
          },
          {
            id: 2,
            imageOneUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-3.png`,
            imageTwoUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-4.png`, 
            title: 'The document should stand out clearly against the background',
          },
          {
            id: 3,
            imageOneUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-1.png`,
            imageTwoUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-5.png`, 
            title: 'Leave a clear space around the document and ensure it fills most of the image',
          },
          {
            id: 4,
            imageOneUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-1.png`,
            imageTwoUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-6.png`, 
            title: 'Make sure the document is bright enough without using the camera flash',
          },
          {
            id: 5,
            imageOneUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-1.png`,
            imageTwoUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-7.png`, 
            title: 'Ensure the image is sharp, focused, and free from blurriness',
          },
          {
            id: 6,
            imageOneUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-1.png`,
            imageTwoUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-8.png`, 
            title: 'Ensure that your hands or other objects do not cover any data on the document',
          },
          {
            id: 7,
            imageOneUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-1.png`,
            imageTwoUrl: `${process.env.VUE_APP_FILE_SERVICE_URL}logo/GS-9.png`, 
            title: 'Ensure the image is of high-resolution, preferably in Full HD',
          },
          // Add more slides as needed
        ],
    };
  },
  computed:{
    ...mapGetters['getRegState'],
  
    isShowGuide() {
      return this.$store.state.registration.isShowGuide
    },
  },
  watch: {},
  methods: {
    ...mapMutations(['setValue']), 
    onSubmit(){
      this.currentSlide = 0
      this.setValue({
                                key: 'isShowGuide',
                                value: false,
                            })
    },
    closeGuide() {
      this.currentSlide = 0
      this.setValue({
                                key: 'isShowGuide',
                                value: false,
                            })
    },
    prevSlide() {
      this.$refs.guideCarousel.prev();
    },
    nextSlide() {
      this.$refs.guideCarousel.next();
    },
  },
};
</script>

<style scoped>
.btn-disabled{
  background-color: #E4E4E4;
  color: #868686 !important;
}
.btn{
  top:30px;
  left: 244px !important;
  text-transform :none;
  border-radius:8px;
  height: 42px;
  width: 166px;
  text-align: center;
  /* font: normal normal normal 15px/18px SF Pro; */
  font-family: "ProximanovaSemibold";
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
}
.carousel-sub-title{
  text-align: center;
  /* font: normal normal normal 15px/22px SF Pro Text; */
  color: #000000;
  font-family: "ProximanovaSemibold";

}
.carousel-indicators {
    margin-top: 47px;
}
.carousel-control-next {
    margin-top: 145px;
}
.carousel-control-prev {
    margin-top: 145px !important;
}
.guide-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.guide-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.guide-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 25px;
  z-index: 11;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 700px; /* Adjust width as needed */
  height: 500px;
}
.guide-title {
  margin-bottom: 20px;
  text-align: center;
  font-size: 1.2rem; /* Adjust font size as needed */
  /* font: normal normal normal 24px/29px SF Pro Display; */
  font-family: "ProximanovaSemibold";
  letter-spacing: 0px;
color: #000000;
}

.slide-content {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  width: 400px;
  margin-top: 80px;
}

.slide-image {
display: inline;
top: 289px;
left: 687px;
width: 300px;
height: 168px;
border: 1px solid #E4E4E4;
border-radius: 8px;
opacity: 1;
margin-right: 10px;

}

.slide-text {
  flex: 1;
  font-size: 0.9rem; /* Adjust font size as needed */
}

.guide-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

button {
word-wrap: normal;
border: none;
background: none;
padding: 10px 20px;
/* top: 540px; */
left: 930px;
width: 31px;
height: 18px;
/* UI Properties */
text-align: right;
/* font: normal normal medium 15px/24px SF Pro; */
font-family: "ProximanovaSemibold";
letter-spacing: 0px;
color: #868686;
opacity: 1;
}
</style>
